import React, { Component, Fragment } from 'react';
import Input from '../FormInput/index';
import Dropdown from 'Components/Dropdown';
import { SHOW_TAT, TAT_UNITS_LAT } from 'Constants/commonConstants';
import { COUNTER_REJECT, COUNTER_ACCEPT, HIKAL } from 'Constants/commonConstants';
import Cx from 'classnames';
import { ReactComponent as DeleteIcon } from 'Icons/delete.svg';
import { isDesmet } from 'Utils/index';
import { Wrapper } from 'Components/Common/Wrapper/index';
import { LabelT6 } from 'Components/Common/Label/index';
import { Spacer } from 'Components/Common/Spacer/index';
import SelectT1 from 'Components/Common/Select/SelectT1';
import { getItemFromSessionStorage, removeItemToSessionStorage } from 'Utils/sessionStorage';
import moment from 'moment';

const SelectStyles = {
   control: (styles, state) => {
      return {
         ...styles,
         border: 'none', 
         boxShadow: state.isFocused ? '0 0 0 1px #000' : 'none', 
         borderRadius: '4px', 
         minHeight: 'initial', 
         height: '30px', 
         minWidth: '150px', 
         borderBottom: 'solid 1px #d8dbf0',
      };
   },
   option: (styles, state) => {
      return {
         ...styles,
      };
   },
};


export default class PostBidFields extends Component {
   constructor(props) {
      super(props);
      const { biddingDetails, lineItem } = this.props;
      const priceUpdated = JSON.parse(localStorage.getItem('isPriceUpdated'));
      this.state = {
         price: biddingDetails.price || '',
			price_usd: biddingDetails.price_usd || '',
         price_secondary: biddingDetails.price_secondary || '',
         // legCostName: biddingDetails.legCostName || '',
         priceInBaseCurrency: biddingDetails.priceInBaseCurrency,
         priceInBaseCurrencySymbol: biddingDetails.priceInBaseCurrencySymbol,
         transporterVol: biddingDetails.transporterVol || '',
         tatValue: (biddingDetails.tat || {}).tatValue,
         tatUnit: {
            unit: ((biddingDetails.tat || {}).tatUnit || {}).tatUnit,
            name: ((biddingDetails.tat || {}).tatUnit || {}).tatUnitName
         },
         originalPrice: biddingDetails.price || '',
         originalTatValue: (biddingDetails.tat || {}).tatValue || '',
         originalTatUnit: ((biddingDetails.tat || {}).tatUnit || {}).tatUnit || 1,
         isPriceUpdated: false || priceUpdated,
			shippingLineName: biddingDetails.shippingLineName,
			containerFreeDay: biddingDetails.containerFreeDay,
         containerDaysHours: biddingDetails.containerDaysHours || 1,
         containerFree: biddingDetails.containerFree || '',
         containerFeeDaysHours: biddingDetails.containerFeeDaysHours || '',
         bid_remarks: biddingDetails.bid_remarks || '',
         number_of_vehicle:'',
         transporter_vehicle: lineItem.transporter_vehicle || [{}],
         showVehicleSizeInputField:false,
         is_multiple_vehicle: lineItem.is_multiple_vehicle || false
      };
   }

   componentWillReceiveProps(nextProps) {
      const priceUpdated = JSON.parse(localStorage.getItem('isPriceUpdated'));
      const submitAll = JSON.parse(localStorage.getItem('submit_all'));
      const vehicleUpdated = JSON.parse(localStorage.getItem('vehicleUpdated'));
      const {isWithdrawBid, isAccessBidWithdrawn} = this.props;
      this.setState({
         price: (((isWithdrawBid && !isAccessBidWithdrawn) || (isAccessBidWithdrawn && isWithdrawBid)) && !priceUpdated) ? (nextProps.biddingDetails.price || '') : ((this.state.isPriceUpdated || priceUpdated) && !submitAll) ? this.state.price : (nextProps.biddingDetails.price || ''),
			price_usd: (((isWithdrawBid && !isAccessBidWithdrawn) || (isAccessBidWithdrawn && isWithdrawBid)) && !priceUpdated) ? (nextProps.biddingDetails.price_usd || '') :((this.state.isPriceUpdated || priceUpdated) && !submitAll) ? this.state.price_usd : (nextProps.biddingDetails.price_usd || ''),
         price_secondary: ((isWithdrawBid && !isAccessBidWithdrawn) || (isAccessBidWithdrawn && isWithdrawBid)) ? (nextProps.biddingDetails.price_secondary || '') : ((this.state.isPriceUpdated || priceUpdated) && !submitAll) ? this.state.price_secondary : (nextProps.biddingDetails.price_secondary || ''),
         tatValue: (this.state.isPriceUpdated || priceUpdated) ? this.state.tatValue : (nextProps.biddingDetails.tat || {}).tatValue,

         tatUnit: {
            unit: (this.state.isPriceUpdated || priceUpdated) ? this.state.tatUnit.unit : ((nextProps.biddingDetails.tat || {}).tatUnit || {}).tatUnit,
            name: (this.state.isPriceUpdated || priceUpdated) ? this.state.tatUnit.name : ((nextProps.biddingDetails.tat || {}).tatUnit || {}).tatUnitName,
         },
         originalPrice: nextProps.biddingDetails.price || '',
         originalTatValue: (nextProps.biddingDetails.tat || {}).tatValue || '',
         originalTatUnit: ((nextProps.biddingDetails.tat || {}).tatUnit || {}).tatUnit || 1,
         transporterVol: (this.state.isPriceUpdated || priceUpdated) ? this.state.transporterVol : (nextProps.biddingDetails.transporterVol || ''),
         transporter_vehicle: ((this.state.isPriceUpdated || priceUpdated || vehicleUpdated) && !submitAll) ? this.state.transporter_vehicle : (nextProps.lineItem.transporter_vehicle || [{}])
      });
      if (nextProps.isPriceOptimized) {
         this.setState({ price: nextProps.handlingPriceInvoked }, () => {
            this.submit();
         });
      }
   }

   onChange = (e) => {
      const { readOnly, biddingDetails, completeSolution, rfq, isWithdrawBid, isAccessBidWithdrawn } = this.props;
      if (readOnly) {
         return;
      }

      if (e.currentTarget.name === "price" && e.currentTarget.value <= 0 && !isDesmet(rfq.companyId)) {
         if (e.currentTarget.value !== '' || e.currentTarget.value === 0) {
            return;
         }
      }

      if (!JSON.parse(localStorage.getItem('termsAndConditionsAccepted'))) {
         alert('Kindly Read And Accept Terms And Conditions');
         setTimeout(() => { window.scrollTo(0, 150); }, 500);
         return;
      }
      if ((e.currentTarget.name === "price" && e.currentTarget.value > 0) || (e.currentTarget.name === "transporterVol") || (e.currentTarget.name === "tatValue") || (e.currentTarget.name === 'bid_remarks')) {
         this.setState({ isPriceUpdated: true });
         localStorage.setItem('isPriceUpdated', 'true');
         localStorage.setItem('submit_all', 'false');
      }
      const val = e.currentTarget.value;

      let typeToAddRemoveUpdate = 1;
      if (!((rfq.companyId === '737' && (rfq && !rfq.rfqDetails.acceptPartialSolution)) ? (isWithdrawBid && isAccessBidWithdrawn) : false) && ((biddingDetails.price === Number(e.currentTarget.value)) || (biddingDetails.transporterVol === e.currentTarget.value) || (biddingDetails.tatValue === e.currentTarget.value))) {
         typeToAddRemoveUpdate = 3;
      }
      let data = {};

      if (e.currentTarget.name === "price") {
         data = {
            trip_id: this.props.trip_id,
            price: Number(e.currentTarget.value),
            transporterVol: this.state.transporterVol,
            tat: {
               unit: this.state.tatUnit.unit,
               value: Number(this.state.tatValue),
               name: this.state.tatUnit.name
            }
         }
      }
      else if (e.currentTarget.name === "tatValue") {
         localStorage.setItem('submit_all', 'false');
         typeToAddRemoveUpdate = 1;
         data = {
            trip_id: this.props.trip_id,
            price: this.state.price,
            transporterVol: this.state.transporterVol,
            tat: {
               unit: this.state.tatUnit.unit,
               value: Number(e.currentTarget.value),
               name: this.state.tatUnit.name
            }
         }
      }
      else {
         data = {
            trip_id: this.props.trip_id,
            price: this.state.price,
            transporterVol: e.currentTarget.value,
            tat: {
               unit: this.state.tatUnit.unit,
               value: Number(this.state.tatValue),
               name: this.state.tatUnit.name
            }
         }
      }
      if(biddingDetails.rfqType === 6) {
         data['bid_remarks'] = this.state.bid_remarks;
      }
      this.setState({
         [e.currentTarget.name]: e.currentTarget.value
      }, () => {
         this.props.saveListOfObjects(data, typeToAddRemoveUpdate);
      });
   }

   onSelect = (value) => {
      const { readOnly, biddingDetails } = this.props;
      if (readOnly && biddingDetails && (biddingDetails.rfqType === 2 || biddingDetails.rfqType === 5)) {
         return;
      }
      let { tatUnit } = this.state;
      var typeToAddRemoveUpdate = 1;

      if ((biddingDetails.tat.tatUnit.tatUnit === value.value)) {
         typeToAddRemoveUpdate = 3;
      }

      this.setState({ isPriceUpdated: true });
      localStorage.setItem('isPriceUpdated', 'true');
      localStorage.setItem('submit_all', 'false');
      if (value) {
         tatUnit = {
            name: value.name,
            unit: value.value,
         }
         let data = {};
         data = {
            trip_id: this.props.trip_id,
            price: this.state.price,
            transporterVol: this.state.transporterVol,
            tat: {
               unit: value.value,
               value: Number(this.state.tatValue),
               name: value.name
            }
         }
         this.setState({ tatUnit });
         this.props.saveListOfObjects(data, typeToAddRemoveUpdate);
      }
   }

   submit = (e) => {
      const { isMaterialsViewAtleastOneTime } = this.state;
      const { rfq }  = this.props;
      const data = {
         trip_id: this.props.trip_id
      }
      if ((Number(this.state.price) === '' || Number(this.state.price) === 0 || Number(this.state.price) === null)) {
         alert("Please Enter Price");
         return;
      }
      this.props.saveListOfObjects(data, 2);
      if (e && e.preventDefault && e.stopPropagation) {
         e.stopPropagation();
         e.preventDefault();
      }
      if (Number(this.state.price) === 0) {
         alert("Please Enter Price");
         return;
      }
      const payloadData = {
         transporterVol: this.state.transporterVol,
         tat: {
            unit: this.state.tatUnit.unit,
            value: Number(this.state.tatValue),
            name: this.state.tatUnit.name
         }
      };
      if (this.props.isCounter && this.props.hasTripBidEnd) {
         payloadData['counter_price'] = Number(this.state.price);
         payloadData['is_counter'] = true;
         payloadData['type'] = 1;
      } else {
         payloadData['price'] = Number(this.state.price);
         payloadData['type'] = 0;
      }
      if(this.props.biddingDetails.rfqType === 5 && !HIKAL.includes(this.props.rfq.companyId)) {
         payloadData['shipping_line_name'] = this.state.shippingLineName;
         payloadData['container_free_day'] = this.state.containerFreeDay && Number(this.state.containerFreeDay);
         payloadData['container_days_hours'] = this.state.containerDaysHours
      }
      if(this.props.biddingDetails.rfqType === 6) {
         payloadData['bid_remarks'] = this.state.bid_remarks;
      }

      if(isDesmet(rfq.companyId)){
         const number_of_vehicle = this.state.number_of_vehicle
         const { transporter_vehicle, is_multiple_vehicle } = this.state;
         const  C1 = !getItemFromSessionStorage("isMaterialsViewAtleastOneTime")
         const  C4 = this.isBiddingEnd()
         const verror = [];
         const diffVehicle = [];
         
         if(C1 && !C4){
            alert("Please view materials");
            return;
         }

         if(!C4) {
            (transporter_vehicle || []).map((el) => {
               if(!el.name && !verror.includes('vehicle type')) {
                  verror.push('vehicle type');
               } 
               if(!el.number_of_vehicle && !verror.includes('number of vehicle')) {
                  verror.push('number of vehicle');
               } 
               if(!el.price_per_vehicle && !verror.includes('price per vehicle')) {
                  verror.push('price per vehicle');
               }      
               if(!diffVehicle.includes(el.id)) {
                  diffVehicle.push(el.id);
               }
            });

            if(verror.length > 0) {
               alert(`Please enter ${verror.toString()}`);
               return;
            }
            if(is_multiple_vehicle && diffVehicle.length === 1) {
               alert(`Please select 2 different vehicle types`);
               return;
            }
         }
         
         // payloadData['number_of_vehicle'] = +number_of_vehicle
         payloadData['transporter_vehicle'] = transporter_vehicle;
         payloadData['is_multiple_vehicle'] = is_multiple_vehicle;
         // payloadData['vehicle_size'] = vehicle_size

         removeItemToSessionStorage("isMaterialsViewAtleastOneTime")
      }
      this.setState({ isPriceUpdated: false });
      localStorage.setItem('isPriceUpdated', 'false');
      localStorage.setItem('vehicleUpdated', 'false');
      this.setState({ price: this.props.biddingDetails.price });
      this.props.submit(payloadData);

   }

   onChangeEXIM = (e) => {
      const { name, value } = e.currentTarget;
      this.setState({
         [name]: value
      })
   }

   onSelectEXIM = (value) => {
      this.setState({ containerDaysHours: value.value });
   }

   handleOnChangeForVehicleDetails = (data, index) => {
      if (!JSON.parse(localStorage.getItem('termsAndConditionsAccepted'))) {
         alert('Kindly Read And Accept Terms And Conditions');
         setTimeout(() => { window.scrollTo(0, 150); }, 500);
         return;
      }
      if(data && (data.id === 445)) {
         this.setState({
            is_multiple_vehicle: true,
            showVehicleSizeInputField: false,
            transporter_vehicle: [{
               number_of_vehicle: '',
               price_per_vehicle: '',
               price: ''
            }]
         }, this.updatePrice);
         return;
      }
      this.setState((prevState) => {
        const updateState = { ...prevState };
        const updateVehicleDetails = {
         name: !!data ? data.name : null,
         id: !!data ? data.id : null,
         number_of_vehicle: '',
         price_per_vehicle: '',
         price: ''
        };
        if(!Array.isArray(updateState.transporter_vehicle)) {
         updateState.transporter_vehicle = [];
        }
        updateState.transporter_vehicle[index] = { ...updateVehicleDetails };
        const C1 = !!data && [76,183].includes(data.value)
        if(C1){
         updateState.showVehicleSizeInputField = true;
        }else{
         updateState.showVehicleSizeInputField = false;
        }
        localStorage.setItem('vehicleUpdated', 'true');
        return updateState;
      }, this.updatePrice);
    };

    handleGetVehicleDetails = () => {
      let { transporter_vehicle  } = this.state;
      transporter_vehicle = !!transporter_vehicle?transporter_vehicle:{} 
      transporter_vehicle.label = transporter_vehicle.name;
      transporter_vehicle.value = transporter_vehicle.id;
      const C1 = !!!transporter_vehicle.name;
      const C2 = !!!transporter_vehicle.id;
      if (C1 && C2) {
        return null;
      }
      return transporter_vehicle;
    };
   isBiddingEnd = ()=>{
       const {rfq} = this.props;
       const  C1  = rfq.rfqDetails.biddingEnd < moment().valueOf()
       if (C1) {
         return true
       }
        return false
   }

   getReBiddingStatus = () => {
      const { rfq, systemTime, lineItem } = this.props;
      let readFlag = false;
      if(rfq.rfq_re_bidding_end && rfq.rfq_re_bidding_end > systemTime) {
         if(!lineItem.trip_re_bidding) {
            readFlag = true;
         }
      }
      return readFlag;
   }

   changeTransVehicle = (e, index) => {
      const { name, value } = e.currentTarget;
      this.setState((prevState) => {
         const updateState = { ...prevState };
         if(!Array.isArray(updateState.transporter_vehicle)) {
            updateState.transporter_vehicle = []
         }
         updateState.transporter_vehicle[index][name] = ((['number_of_vehicle', 'price_per_vehicle'].includes(name) && value) ? +value : value);
         if(updateState.transporter_vehicle[index].number_of_vehicle && updateState.transporter_vehicle[index].price_per_vehicle) {
            updateState.transporter_vehicle[index]['price'] =  (+updateState.transporter_vehicle[index].number_of_vehicle * +updateState.transporter_vehicle[index].price_per_vehicle)
         }
         return updateState;
      }, this.updatePrice);
   }

   updatePrice = () => {
      const { transporter_vehicle } = this.state;
      let total = 0;
      (transporter_vehicle || []).map((el, vIndex) => {
         if(el.number_of_vehicle && el.price_per_vehicle) {
            total +=  (+el.number_of_vehicle * +el.price_per_vehicle);
         }
      })
      if(total > 0 || (this.state.price)) {
         this.onChange({
            currentTarget : {
               value: total,
               name: 'price'
            }
         })
      }
   }

   addVehicle = () => {
      const { transporter_vehicle } = this.state;
      transporter_vehicle.push({});
      this.setState({
         transporter_vehicle
      })
   }

   multiVehicleChange = (option) => {
      if(option.id !== 445) {
         this.setState({
            transporter_vehicle: [{
               name: option.name,
               id: option.id,
               number_of_vehicle: '',
               price_per_vehicle: '',
               price: ''
            }],
            showVehicleSizeInputField: (option.id === 183),
            is_multiple_vehicle: false
         }, () => {
            this.onChange({
               currentTarget : {
                  value: 0,
                  name: 'price'
               }
            })
         });
      }
   }

   getMultiVehicleData = () => {
      const { price } = this.state;
      const { vehicleTypesList } = this.props;
      return (
         <tr className='mb-5'>
            <td>
               <div className='pr-10 ml-10 flex flex-column gap-10'>
                  <div className="" >
                     {/* <label class="label label-color fRegular no-transition fs-12">Vehicle Types</label> */}
                     <SelectT1
                        placeholder={"Select"}
                        isClearable={true}
                        options={vehicleTypesList}
                        getOptionLabel={(option) => option.name}
                        getOptionValue={(option) => option.id}
                        isSearchable={true}
                        value={(vehicleTypesList || []).find(el => el.id === 445)}
                        onChange={this.multiVehicleChange}
                        styles={SelectStyles}
                     />
                  </div>
               </div>
            </td>
            <td></td>
            <td></td>
            <td className='pl-5'>{price}</td>
         </tr>
      )
   }

   onDeleteVehicle = (index) => {
      const { transporter_vehicle } = this.state;
      transporter_vehicle.splice(index, 1);
      this.setState({
         transporter_vehicle
      }, this.updatePrice)
   }

   getVehicleDetails = () => {
      const { transporter_vehicle, showVehicleSizeInputField, is_multiple_vehicle } = this.state;
      const { vehicleTypesList } = this.props;
      return (
               <table className='wt-500'>
                  <tr>
                     <th>Vehicle Types</th>
                     <th>No. Of Vehicle</th>
                     <th>Price Per Vehicle</th>
                     <th>Total Price</th>
                  </tr>
                  {(is_multiple_vehicle || (transporter_vehicle || []).length > 1) && this.getMultiVehicleData()}
               {(transporter_vehicle || []).map((vehicle, vIndex) => {
                  return (
                        <tr className='mb-5' key={vIndex}>
                           <td>
                              <div className='pr-10 ml-10 flex flex-column gap-10'>
                                 <div className="" >
                                    {/* <label class="label label-color fRegular no-transition fs-12">Vehicle Types</label> */}
                                    <SelectT1
                                       placeholder={"Select"}
                                       isClearable={true}
                                       options={vehicleTypesList}
                                       getOptionLabel={(option) => option.name}
                                       getOptionValue={(option) => option.id}
                                       isSearchable={true}
                                       value={vehicle}
                                       onChange={(option) => this.handleOnChangeForVehicleDetails(option, vIndex)}
                                       styles={SelectStyles}
                                    />
                                 </div>
                     
                                 {(vehicle.id === 183) &&<>
                                    <div>
                                       <label
                                          class="label label-color fRegular no-transition fs-12"
                                          htmlFor='Idvehicle_size'
                                       >
                                          Vehicle Size (l*w*h)
                                       </label>
                                       <input
                                          type="text"
                                          name="vehicle_size"
                                          id="Idvehicle_size"
                                          style={{
                                             borderBottom: 'solid 1px #d8dbf0',
                                             borderRadius: '2px'
                                          }}
                                          value={vehicle.vehicle_size}
                                          onChange={(e) => this.changeTransVehicle(e, vIndex)}
                                       />
                                    </div>
                                 </>}
                              </div>
                           </td>
                           <td>          
                              <div className="pr-5 pt-15 flex ml-10">
                                 <div className="wt-100 mt--15 postbid-label">
                                    {/* <label class="label label-color fRegular no-transition fs-12">No. of Vehicle</label> */}
                                    <input
                                       value={vehicle.number_of_vehicle || ''}
                                       placeholder="Number of vehicle"
                                       name="number_of_vehicle"
                                       onChange={(e) => this.changeTransVehicle(e, vIndex)}
                                       className="col-1 fs-14 no-border ht-30"
                                       style={{
                                          border: 'none',
                                          borderBottom: 'solid 1px #d8dbf0',
                                          background: 'transparent'
                                       }}
                                       noTransition={true}
                                       step="any"
                                       containerClassName="no-transition-container"
                                    />
                                 </div>
                              </div>
                           </td>
                           <td>
                              <div className="pr-5 pt-15 flex ml-10">
                                 <div className="wt-100 mt--15 postbid-label">
                                    {/* <label class="label label-color fRegular no-transition fs-12">Price Per Vehicle</label> */}
                                    <input
                                       value={vehicle.price_per_vehicle}
                                       name="price_per_vehicle"
                                       onChange={(e) => this.changeTransVehicle(e, vIndex)}
                                       className="col-1 fs-14 no-border ht-30"
                                       style={{
                                          border: 'none',
                                          borderBottom: 'solid 1px #d8dbf0',
                                          background: 'transparent'
                                       }}
                                       noTransition={true}
                                       step="any"
                                       containerClassName="no-transition-container"
                                    />
                                 </div>
                              </div>
                           </td>
                           <td>
                              <div className="pr-5 pt-15 flex ml-10">
                                 <div className="wt-100 mt--15 postbid-label">
                                    {/* <label class="label label-color fRegular no-transition fs-12">Total Price</label> */}
                                    <input
                                       value={vehicle.price}
                                       name="price"
                                       onChange={(e) => this.changeTransVehicle(e, vIndex)}
                                       className="col-1 fs-14 no-border ht-30"
                                       style={{
                                          border: 'none',
                                          borderBottom: 'solid 1px #d8dbf0',
                                          background: 'transparent'
                                       }}
                                       noTransition={true}
                                       step="any"
                                       containerClassName="no-transition-container"
                                    />
                                 </div>
                              </div>
                           </td>
                           {(is_multiple_vehicle || transporter_vehicle.length > 1) && <td>
                              <div className='curP fBold fs-26 theme-color tCenter mt-10 flex'>
                                 <div onClick={this.addVehicle}>+</div>
                                 {transporter_vehicle.length > 1 && <DeleteIcon className="ht-15 wt-15 ml-5 curP" onClick={() => this.onDeleteVehicle(vIndex)}/>}
                              </div>
                           </td>}
                        </tr>
                  )
               })
            }</table>)
   }

   render() {
      const { price,
         tatUnit,
         tatValue,
         isPriceUpdated,
         transporterVol,
         price_usd,
         price_secondary,
         shippingLineName,
         containerFreeDay,
         containerDaysHours,
         containerFree,
         containerFeeDaysHours,
         bid_remarks,
         legCostName,
         priceInBaseCurrency,
         priceInBaseCurrencySymbol,
         number_of_vehicle,
         showVehicleSizeInputField,
         price_per_vehicle,
         transporter_vehicle
      } = this.state;
      const { biddingDetails, pricingBasisName, readOnly, isLot, saveListOfObjects, trip_id, counterStatus, isAccessBidWithdrawn , isWithdrawBid, showBidStarted, isRILCompleteSolution, rfq ,
         vehicleTypesList,
      } = this.props;
      const completeSolution = rfq && !rfq.rfqDetails.acceptPartialSolution;
      // const currencyType = (this.props.currencyTypes || []).find(el => el.currency_name === legCostName) || {};
      return (
         <div className="flex flex-column pr t-5 postBid-fields">
           { <form onSubmit={this.submit} className="flex">
           {isDesmet(rfq.companyId) && !this.isBiddingEnd() && this.getVehicleDetails()}
            {!isDesmet(rfq.companyId) && <>
               <span className="pr-5 pt-15">₹</span>
               <div className={Cx("wt-60",{
                  'wt-150': isWithdrawBid
               })}>
                  <Input
                     type="number"
                     value={(biddingDetails.rfqType === 5 && price )? Number(price).toFixed(2) : price}
                     placeholder="Price"
                     name="price"
                     onChange={this.onChange}
                     className={"col-1 fs-14 no-border"}
                     noTransition={true}
                     step="any"
                     containerClassName="no-transition-container"
                     disabled={(isAccessBidWithdrawn!==undefined && !isAccessBidWithdrawn) || this.getReBiddingStatus()}
                     onBlur={(['737'].includes(rfq.companyId) && completeSolution && isAccessBidWithdrawn && isWithdrawBid) ? this.onChange : null}
                  />
               </div>
         </>}
               {biddingDetails.rfqType === 5 && priceInBaseCurrency !== 'INR' &&
                  <Fragment>
                  <div className="pr-5 pt-15 flex ml-5"><span>{priceInBaseCurrencySymbol || ''}</span>
                     <div className={Cx("wt-60 mt--15", {
                        'w-150':isWithdrawBid
                     })}>
                        <Input
                           type="number"
                           value={(biddingDetails.rfqType === 5 && (priceInBaseCurrency === 'USD' ? price_usd : price_secondary) ? Number(priceInBaseCurrency === 'USD' ? price_usd : price_secondary).toFixed(2) : (priceInBaseCurrency === 'USD' ? price_usd : price_secondary))}
                           placeholder={`Price (${priceInBaseCurrency})`}
                           name={priceInBaseCurrency === 'USD' ? price_usd : price_secondary}
                           onChange={this.onChange}
                           className="col-1 fs-14 no-border"
                           noTransition={true}
                           step="any"
                           containerClassName="no-transition-container"
                        />
                     </div>
                  </div>
                  </Fragment>
               }
               <span className="pr-5 pt-15"></span>
               {biddingDetails.showTat &&
                  <div className="pl-5 pr-5">
                     <div className="flex">
                        <div className="wt-25">
                           <Input
                              type="number"
                              placeholder="TAT"
                              onChange={this.onChange}
                              value={tatValue}
                              name="tatValue"
                              className="fs-14 no-border"
                              noTransition={true}
                              containerClassName="no-transition-container"
                           />
                        </div>
                        <Dropdown
                           items={TAT_UNITS_LAT}
                           selectedItem={tatUnit.name ? tatUnit : TAT_UNITS_LAT[0]}
                           name="tatUnit"
                           displayKey="name"
                           label=""
                           noBorder={true}
                           className="wt-60"
                           onSelect={this.onSelect}
                        />
                     </div>
                  </div>
               }
               {biddingDetails.rfqType === 5 && !HIKAL.includes(this.props.rfq.companyId) &&
                  <Fragment>
                  <div className="pr-5 pt-15 flex ml-5">
                     <div className="wt-150 mt--15 flex postbid-label">
                     <Input
                        value={shippingLineName}
                        placeholder="Shipping Line"
                        name="shippingLineName"
                        onChange={this.onChangeEXIM}
                        className="col-1 fs-14 no-border"
                        noTransition={true}
                        step="any"
                        containerClassName="no-transition-container"
                     />
                     </div>
                  </div>
                  <div className="pr-5 pt-15 flex ml-5 postbid-label">
                     <div className="wt-150 mt--15 flex">
                        <div className="wt-60">
                           <Input
                              type="number"
                              value={containerFreeDay}
                              placeholder={`Container Free ${containerFree && `(${containerFree} ${containerFeeDaysHours || ''})`}`}
                              name="containerFreeDay"
                              onChange={this.onChangeEXIM}
                              className="col-1 fs-14 no-border"
                              noTransition={true}
                              step="any"
                              containerClassName="no-transition-container"
                           />
                        </div>
                        <Dropdown
                           items={TAT_UNITS_LAT}
                           selectedItem={containerDaysHours &&  TAT_UNITS_LAT.find(TATunit => TATunit.value === containerDaysHours) || null}
                           name="containerDaysHours"
                           displayKey="name"
                           label=""
                           noBorder={true}
                           className="wt-60"
                           onSelect={this.onSelectEXIM}
                        />
                     </div>
                  </div>
               </Fragment>
               }
               {biddingDetails.allowBusinessVolume &&
                  <div className="wt-60 ml-5">
                     <Input
                        type="text"
                        value={transporterVol}
                        placeholder="Availability"
                        name="transporterVol"
                        onChange={this.onChange}
                        className="col-1 fs-14 no-border"
                        noTransition={true}
                        step="any"
                        containerClassName="no-transition-container"
                     />
                  </div>
               }
     
               {pricingBasisName && !isDesmet(rfq.companyId) &&
                  <div className="flex pa b-0 pl-15">
                     <div className="fs-12 op-79 section-sub-header-color pr ml--2">
                        {pricingBasisName}
                     </div>
                  </div>
               }
               {showBidStarted && !price   && 
                 <span className="blinking">Bid Started...</span>
               }
               {biddingDetails.rfqType === 6 &&
                  <Fragment>
                  <div className="pr-5 pt-15 flex ml-5">
                     <div className="wt-100 mt--15">
                        <Input
                           value={bid_remarks}
                           placeholder="Remarks"
                           name="bid_remarks"
                           onChange={this.onChange}
                           className="col-1 fs-14 no-border"
                           noTransition={true}
                           step="any"
                           containerClassName="no-transition-container"
                        />
                     </div>
                  </div>
                  </Fragment>
               }
               {isWithdrawBid && !isAccessBidWithdrawn &&
                     <div className={Cx("fBold fs-14 danger-color pr col-1 t-8 tCenter pt-5 wt-95",{
                        'ml-20': isWithdrawBid
                     })}>
                        Bid Withdrawn 
                        {biddingDetails.bid_withdrawn_price &&<><br/>
                           <div className='fs-12 fBold theme-color'>Withdrawn Price: <span className='danger-color'>{biddingDetails.bid_withdrawn_price}</span></div></>
                        }
                  </div>
               }
               {isAccessBidWithdrawn && isWithdrawBid && <div className="fBold fs-14 green-color pr col-1 t-8 tCenter pt-5 wt-95">
                        Bid Revoked
                        {biddingDetails.bid_withdrawn_price && <><br/>
                           <div className='fs-12 fBold theme-color'>Withdrawn Price: <span className='danger-color'>{biddingDetails.bid_withdrawn_price}</span></div></>
                        }
                  </div>}
               {
                  ((!isRILCompleteSolution && ((((isAccessBidWithdrawn && isWithdrawBid) ? price : (price != (biddingDetails.price || ''))) || (transporterVol != (biddingDetails.transporterVol || ''))
                     || (tatValue != ((biddingDetails.tat || {}).tatValue || ''))
                     || (tatUnit.name != ((biddingDetails.tat || {}).tatUnit.tatUnitName || ''))
                     || (tatUnit.unit != ((biddingDetails.tat || {}).tatUnit.tatUnit || '')) &&
                     (price || transporterVol) && !readOnly) || ((price || transporterVol) && isLot)) && (isPriceUpdated) &&
                     ((rfq.companyId === '737' && this.props.challengePrice && completeSolution) ? true : parseFloat(this.props.challengePrice) !== parseFloat(price)) && !JSON.parse(localStorage.getItem('submit_all'))) && !this.getReBiddingStatus()) &&
                  <div className="fBold theme-color tCenter fs-14 pt-5 curP pr t-8 ml-10" onClick={(e) => this.submit(e)}>
                     Submit
                        </div>
               }
               <input type="submit" className="dNone" />
            </form>}

            {counterStatus === COUNTER_REJECT && <div className="mt-8 mb-20"><span className="header-dark-color bg-reject fs-12 pr-2 pl-2 pt-2 pb-2 br-5">Counter Price Rejected</span></div>}
         </div>
      )
   }
}


